<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Transport Modes
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th>Mode</th>
									<th>Code</th>
									<th>Validity</th>
									<th>Change</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="j in tms" :key="j.id">
									<td>{{j.mode}}</td>
									<td>{{j.code}}</td>
									<td>{{j.validity}}</td>
									<td>
										<button class="btn btn-danger fa fa-square" v-if="j.validity == 'Active'" @click="changeTM(j.id, 'Inactive')"></button>
										<button class="btn btn-success fa fa-play" @click="changeTM(j.id, 'Active')" v-else></button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<div class="col-sm-12">
		  				<div class="row">
		  					<div :class="['form-group', errors.mode ? 'has-error' : '']">
		  						<input type="text" class="form-control" v-model="tmform.mode" placeholder="Enter new mode">
		  						<span v-if="errors.mode" :class="['badge bg-danger']">Please enter a valid mode.</span>
		  					</div>
		  					<div :class="['form-group', errors.code ? 'has-error' : '']">
		  						<input type="text" class="form-control" v-model="tmform.code" placeholder="Enter new code">
		  						<span v-if="errors.code" :class="['badge bg-danger']">Please enter a valid code.</span>
		  					</div>
		  					<div class="form-group">
		  						<button class="btn btn-danger" @click="addTM"><i class="fa fa-plus"></i> Add Transport Mode</button>
		  					</div>
		  				</div>
		  			</div>
					</div>
				</div>
			</div>
			
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Delivery Modes
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th>Mode</th>
									<th>Validity</th>
									<th>Change</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="j in dms" :key="j.id">
									<td>{{j.mode}}</td>
									<td>{{j.validity}}</td>
									<td>
										<button class="btn btn-danger fa fa-square" v-if="j.validity == 'Active'" @click="changeDM(j.id, 'Inactive')"></button>
										<button class="btn btn-success fa fa-play" @click="changeDM(j.id, 'Active')" v-else></button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<div class="col-sm-12">
		  				<div class="row">
		  					<div :class="['form-group', errors.mode ? 'has-error' : '']">
		  						<input type="text" class="form-control" v-model="dmform.mode" placeholder="Enter new mode">
		  						<span v-if="errors.mode" :class="['badge bg-danger']">Please enter a valid mode.</span>
		  					</div>
		  					<div class="form-group">
		  						<button class="btn btn-danger" @click="addDM"><i class="fa fa-plus"></i> Add Delivery Mode</button>
		  					</div>
		  				</div>
		  			</div>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getTMS();
        	this.getDMS();
        },
        
        data(){
        	return {
        		tms: [],
        		tmform: new Form({
        			mode: '',
        			code: ''
        		}),
        		errors: [],
        		dms: [],
        		dmform: new Form({
        			mode: ''
        		})
        	}
        },
        
        methods: {
        	getTMS(){
        		axios.post("/api/getTMS")
        		.then(response => {
        			this.tms = response.data;
        		})
        	},
        	
        	addTM(){
        		this.tmform.post("/api/addTM")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Transport Mode Added!'
        			});
        			this.getTMS();
        		})
        	},
        	
        	changeTM(id, validity){
        		axios.post("/api/changeTM", {id: id, validity: validity})
        		.then(() => {
        			this.getTMS();
        		})
        	},
        	
        	getDMS(){
        		axios.post("/api/getDeliveryModes")
        		.then(response => {
        			this.dms = response.data;
        		})
        	},
        	
        	addDM(){
        		this.dmform.post("/api/addDeliveryMode")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Delivery Mode Added!'
        			});
        			this.getDMS();
        		})
        	},
        	
        	changeDM(id, validity){
        		axios.post("/api/changeDeliveryMode", {id: id, validity: validity})
        		.then(() => {
        			this.getDMS();
        		})
        	}
        }
    }
</script>
